import { render, staticRenderFns } from "./BbsList.vue?vue&type=template&id=47f66e2b&scoped=true"
import script from "./BbsList.vue?vue&type=script&lang=ts"
export * from "./BbsList.vue?vue&type=script&lang=ts"
function injectStyles (context) {
  
  var style0 = require("./BbsList.vue?vue&type=style&index=0&id=47f66e2b&prod&lang=scss&scoped=true")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "47f66e2b",
  "35661bca"
  
)

export default component.exports